import {
  isRangeSearchableField,
  type SearchableField,
} from './ISearchableField.tsx';

export function getSearchableFieldNames(field: SearchableField): string[] {
  if (isRangeSearchableField(field)) {
    return [field.from.name, field.to.name];
  }
  return [field.name];
}
